import { Heading } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import styled from 'styled-components'

export const Wrapper = styled.div`
  margin: auto;
  max-width: 1080px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const HeaderChildrenContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const IconContainer = styled.img<{ $color?: string }>`
  width: 38px;
  height: 38px;
  background-color: ${(props) => props?.$color};
  border-radius: 9px;
  padding: 8px;
`

export const ModalFooter = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 12px;
`

export const ConfirmationModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  color: ${(props) => props.theme.color.neutral.color3};
`

export const ConfirmationModalTitleContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`

export const LogTitle = styled(Heading)`
  color: ${({ theme }) => theme.color.neutral.color3};
`

export const LogSubtitle = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
`
